var url_send ="https://cureveda-otp-0d18c55b5004.herokuapp.com/";
var site_url = "https://cureveda.com/";
var body_class = $('body').attr('class');
    
$(document).ready(function(){
 
  $('body').on('click','.get-details',function(){
    const get_user_name = document.querySelector('.get-user_name').value;
    var mobile_number_value = $("#phn-num").val();
    const get_user_email = document.querySelector('.get-user_email').value;
    const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    let email_error_msg = document.querySelector('.email-error-msg');
    let name_error_msg = document.querySelector('.name-error-msg');

    if(get_user_name == ""){
        name_error_msg.innerText = "Enter Full Name";    
    }else{
        name_error_msg.innerText = "";
    }

    if(get_user_email == ""){
        email_error_msg.innerText = "Enter Email";    
    }else{
        email_error_msg.innerText = "";
    }
    
    if(get_user_name != '' && get_user_email.match(validRegex)){
      $.ajax({
          url:`https://cureveda-otp-0d18c55b5004.herokuapp.com/emailUpdate/eUpdateMob.php?m=`+mobile_number_value+`&em=${get_user_email}&case=update_all&encry=false&f=${get_user_name}`,
          type:"post",
          async:false,
          success:function(data){
            // console.log('data..',data)
            if(data == '3'){
              window.location.href = "/account";
            }else{
              //window.location.href = "";// commented on 27 07 24 due to user email issue
              email_error_msg.innerText = "Email is already in used"; // added on 27 07 24 due to user email issue
            }
          }
      })
    }else{
      email_error_msg.innerText = "Enter valid email";
    }
    // console.log(get_user_name,'1....',get_user_email);
  })
  
  $('.back_mobile_from, .checkout-otp-back').click(function(event){
    $(".div_mobile_number_otp, .checkout-otp-back").hide();
    $("#otp___btn #btn_text ").show();
    $("#otp___btn #lodar__otp").hide();
    $(".div_mobile_number_value, .checkout-back-icon").show();
  }); 
  
    function login_customer(cust_id,time_value){
      // console.log("login_customer");
      var time_value_data = time_value;
      var mobile_number_value = $("#phn-num").val();

      var checked_newsletter = $('#checkbox-2').prop('checked');
      // console.log("login_customer",checked_newsletter);  
     
      // console.log("after if login_customer",checked_newsletter);
      $("#error_without_from_submit_mobile").hide();
      //window.location.href = site_url + time_value;
       var login_url = time_value;
      $.ajax({
        url:login_url,
        type:"get",            
        async:false,
        success:function(data){  
          // console.log('data...',data)
          
          const dom = new DOMParser()
          const html = dom.parseFromString(data,'text/html')
          const customer_email = html.querySelector('.customer_account')?.getAttribute('customer-email')
          // console.log('html...',customer_email)

          
          var error = $(data).find(".Alert--error").text();
          var redirect_after_login =  localStorage.getItem('redirect_after_login');
          if((error == "") && (redirect_after_login == "1")){
            localStorage.setItem('setup','1');
            //var key_value = $("#mobile_number_otp").val();
			var key_value = '';
			 $('.otp_input input').each(function(){
				key_value += $(this).val();
			  });
            if(cust_id == ""){
                after_login_add_no_cid(cust_id , key_value,time_value);
            }else{
            	after_login_add(cust_id , key_value,time_value);
            }
            //window.location.href = "/checkout?step=contact_information";
          }else if((error == "") && (redirect_after_login == "0")){
            const htmlContent = `
            <p class="email-box-para font-size-content"><span class="font-bold">Welcome!</span><br>
                <span>Create your account for a seamless experience</span>
            </p>
            <div class="name-box">
                <img src="https://cdn.shopify.com/s/files/1/0559/0594/3598/files/icon-user.png?v=1708863069" width="27" height="27">
                <input type="text" class="get-user_name" placeholder="Enter Full Name">
            </div>
            <p class="name-error-msg"></p>
            <div class="email-input-box">
                <img src="https://cdn.shopify.com/s/files/1/0559/0594/3598/files/icon-mail.png?v=1708863069" width="27" height="27">
                <input type="email" class="get-user_email" placeholder="Enter Email">
            </div>
            <p class="email-error-msg"></p>
            <div class="cstm_blank_div">
                <button type="submit" class="get-details background-brown" id="login_btn">
                    <img src="//www.cureveda.com/cdn/shop/files/icon-right-arrow-next.png?v=1706077938" alt="next_button" title="Proceed" loading="lazy" class="proceed_btn" width="27" height="27">
                </button>
            </div>
        `;
            if((body_class.match('template-login')) || (body_class.match('template-page'))){
              if(customer_email.includes('@example.com')){
                document.querySelector('.otp_box').style.display = "none";
                document.querySelector('.sign-up').style.display = "block"
                document.querySelector('.login-heading').style.display = "none"
                document.querySelector('.email-box').style.display = "block";
                document.querySelector('.email-box').innerHTML = htmlContent;
              }else{
                 window.location.href = "/account";
              }
              }else{
                 window.location.href = "";
              }
          }else{         
            $("#error_without_from_submit_mobile").text(error);
            $("#error_without_from_submit_mobile").show();
          }

        },error:function(jqXHR, exception){

        }
      });
    }
    
    function after_login_add_no_cid(cust_id , key_value,time_value){
      
      var mobile_number_value = $("#phn-num").val();
      // console.log("mohit after_login_add_no_cid",mobile_number_value,$("#phn-num"));
      var key = key_value;
      $(".div_mobile_number_value").hide();
      $(".div_mobile_number_otp, .checkout-otp-back").hide();
      $(".checkout-back-icon").show();
      $("#checkout_email_or_phone").val("+91"+mobile_number_value);
      $("#checkout_shipping_address_phone").val(mobile_number_value);
      $(".flag-selector__select").val("IN").change();
      $(".section--shipping-address").css("background-color","#fff");
      $(".section--shipping-address").css("opacity","1");
      $(".section--shipping-address").css("border-color","#cccccc");
      $(".section--shipping-address :input").attr("disabled", false);
      $(".dummy_btn_new").css("opacity","1");
      $(".dummy_btn_new").css("pointer-events","auto");
      $("#continue_button").attr("disabled", false).css("background-color", "#1306bf");
      //$("#continue_button").show();
      $("#continue_button").hide();
      $("#dummy_continue_button_info").show();
   }
    
    function after_login_add(cust_id , key_value,time_value){
        var mobile_number_value = $("#phn-num").val();
      // console.log("mohit after_login_add",mobile_number_value,$("#phn-num"));
        var key = key_value;

        var customer_tags ='mobile_reg';   
        var get_data_url = url_send+"after_login_add.php?c="+cust_id+"&m="+mobile_number_value+"&t="+customer_tags+"&k="+key_value;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
                 
          if (this.readyState == 4 && this.status == 200) {
                     var data = JSON.parse(atob(this.responseText));

                      var f=data.f;
                      var l=data.l;
                      var a1=data.a1;
                      var a2=data.a2;
                      var c=data.c;
                      var p=data.p;
                      var co=data.co;
                      var ph=data.ph;
                      if(ph==""){
                        ph = mobile_number_value;
                      }
                      var p_code=data.p_code;
                      var c_code=data.c_code;
                      var c_name=data.c_name;
            
                      sessionStorage.setItem("f", f);
                      sessionStorage.setItem("l", l);
                      sessionStorage.setItem("a1", a1);
                      sessionStorage.setItem("a2", a2);
                      sessionStorage.setItem("c", c);
                      sessionStorage.setItem("p", p);
                      sessionStorage.setItem("co",co);
                      sessionStorage.setItem("ph",ph);
                      
                      sessionStorage.setItem("mo",mobile_number_value);
                      sessionStorage.setItem("p_code",p_code);
                      sessionStorage.setItem("c_code",c_code);
                      sessionStorage.setItem("c_name",c_name);
                      sessionStorage.setItem("cust_id",cust_id); 
            
                      $(".div_mobile_number_value").hide();
                      $(".div_mobile_number_otp, .checkout-otp-back").hide();
                      $(".checkout-back-icon").show();
            
                      $("#checkout_email_or_phone").val("+91"+mobile_number_value);
            
                      $(".flag-selector__select").val("IN").change();
            
                      $("#checkout_shipping_address_first_name").val(f);
                      $("#checkout_shipping_address_last_name").val(l);
                      $("#checkout_shipping_address_address1").val(a1);
                      //$("#checkout_shipping_address_city").val(c);
                      $("#checkout_shipping_address_phone").val(ph);
                      $("#checkout_shipping_address_phone").attr("data-phone-formatter-country-code","91");
                      //$("#checkout_shipping_address_province").val(p_code);
            
                      $(".section--shipping-address").css("background-color","#fff");
                      $(".section--shipping-address").css("opacity","1");
                      $(".section--shipping-address").css("border-color","#cccccc");
                      $(".section--shipping-address :input").attr("disabled", false);
                      $(".dummy_btn_new").css("opacity","1");
                      $(".dummy_btn_new").css("pointer-events","auto");
                      $("#continue_button").attr("disabled", false).css("background-color", "#1306bf");
                      //$("#continue_button").show();
                      $("#continue_button").hide();
                      $("#dummy_continue_button_info").show();    
          }
        };
        xhttp.open("POST", get_data_url, true);
        xhttp.send(); 
  
    }
 
  
    function registerUser(cust_id , key_value,time_value){
      var mobile_number_value = $("#phn-num").val();	        
      var key = key_value;
      var page_url = window.theme.canonical_url;
      var customer_tags = '';
      if(page_url.match("pepsodent")){
        customer_tags = 'Dentist';
      }else{
        customer_tags ='mobile_reg';
      }
        var get_data_url = url_send+"verify_process.php?m="+mobile_number_value+"&t="+customer_tags+"&k="+key_value;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
          if (this.readyState == 4 && this.status == 200) {
                     var data = JSON.parse(atob(this.responseText));
                     
                     //var customer_id_update = $(data).find("#c_uid").val();
                     var customer_id_update = data.time;
                     var time_value = data.date;
                    if(customer_id_update == undefined){
                      $(".verify_code").trigger("click");
                    }else{
                      var checked_newsletter = $('#checkbox-2').prop('checked');
					  login_customer(cust_id,time_value);
                    }
  
          }
        };
        xhttp.open("POST", get_data_url, true);
        xhttp.send(); 
  
    }  
    
  $('.send_code').click(function(){
        var mobNumber = $("#phn-num").val();
        var phone_regex = /^[6789][0-9]{4}([ ]?)[0-9]{5}$/;
            //var phone_regex = /^$/;
            if(!phone_regex.test(mobNumber)) {
               $('#phone_error').css("color","red").show();
            }else{
              if(mobNumber != ""){
                  $('#phone_error').hide();
                  mobileVerification(mobNumber);
                  
              }
            }
  });
  
  $('.back-otp-arrow').click(function(){        //new design
    $('.login-number-box').show();
    $('.otp_box').hide();
  });
    
  function mobileVerification(mobNumber){
      //var mobUrl = "http://newpetsessentia.ens.enterprises/index.php?mobile_number="+mobNumber;
      var mobUrl = url_send+"send_otp.php?mobile_number="+mobNumber;
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          //countdown(61);
          var redirect_after_login =  localStorage.getItem('redirect_after_login');
         
          timer(60); 
          $('.otp_box').show(); //new design
          $('.login-number-box').hide();//new design
          $(".div_mobile_number_value, .checkout-back-icon").hide();
          //$(".mobile_numbers_otp").val(mobNumber);
          $(".div_mobile_number_otp, .checkout-otp-back").show();
          var otpsendToMobileMsg = "+91 "+mobNumber;
          $(".otpsendToMobile").html(otpsendToMobileMsg);
  
        }
      };
      xhttp.open("GET", mobUrl, true);
      xhttp.send();
  }
    
  
  $('#phn-num').keyup(function(e){
           
            var phoneNum = $(this).val();
            $("#checkout_email_or_phone").val(phoneNum);
            $("#checkout_email_or_phone").trigger("keyup");
            $(".field--email_or_phone input[type=hidden]").val("+91"+phoneNum);
            var phone_regex = /^[6789][0-9]{4}([ ]?)[0-9]{5}$/;
            //var phone_regex = /^$/;
            if(!phone_regex.test(phoneNum)) {
              //$('#phone_error').show();
               $('#phone_error').hide();
               //$('.send_code').prop('disabled',true);
            }
            else{
              $('#phone_error').hide();
              //$('.send_code').prop('disabled',false);
            }
           
  });  
  $('.verify_code').click(function(){
        var thisV  = $(this);
        //thisV.find("input").val("Verifying..");
         //$(".back_mobile_from").hide();
         //var mobNumber = $('.mobile_numbers_otp').val();
         var mobNumber = $("#phn-num").val();
         //var otpNumber = $("#mobile_number_otp").val();
		 var otpNumber = '';
		 $('.otp_input input').each(function(){
            otpNumber += $(this).val();
          });  
         var mobotpUrl = url_send+"check_otp.php?mobile_no="+mobNumber+"&otp_code="+otpNumber;
         
         var xhttp = new XMLHttpRequest();
         xhttp.onreadystatechange = function() {
           if (this.readyState == 4 && this.status == 200) {
             
             var json_data = JSON.parse(atob(this.responseText));
             var status = json_data.status;
             var otp_msg = json_data.msg;
             
             if(status == "success"){
                 thisV.find("input").val("Verifying..");
                 //$(".verify_code").text("Verifying..");
                 $(".back_mobile_from").hide();
                 
                 $(".otp_msg_failed").hide();
                 //$(".otp_msg_success").show();
                 $(".progress_img").show();
                var redirect_after_login =  localStorage.getItem('redirect_after_login');
               
                 var url_get_data = url_send+"customer_update.php?key="+otpNumber+"&mobile="+mobNumber+"&case=get_data";
                  var xhttpp = new XMLHttpRequest();
                  xhttpp.onreadystatechange = function() {
                    if (this.readyState == 4 && this.status == 200) {
                      //var customer_details =JSON.parse(JSON.stringify(data1));
                      var customer_details = JSON.parse(atob(this.responseText));
                      var cust_id = customer_details.time;
                      
                      //var cust_email = "";
                      var cust_password = customer_details.flag;
                      var time_value = customer_details.sec;

                      if(cust_id == "" ){
                        registerUser(cust_id, otpNumber,time_value);
                      
                      }else if(cust_id != "" ){
                        login_customer(cust_id,time_value);
                      }
                    }
                  };
                  xhttpp.open("GET", url_get_data, true);
                  xhttpp.send();
             }else{
               thisV.find("input").val("Verify");
               $(".otp_msg_failed").show();
               $(".progress_img").hide();
             } 
           }
         };
         xhttp.open("GET", mobotpUrl, true);
         xhttp.send();
    });  
  
let countdown;
function timer(seconds) {
  clearInterval(countdown);
  const now = Date.now();
  const then = now + seconds * 1000;
  displayTimeLeft(seconds);
  
  //displayEndTime(then);
  countdown = setInterval(() => {
      
    const secondsLeft = Math.round((then - Date.now()) / 1000);
    if(secondsLeft < 0) {
          clearInterval(countdown);
          $('.resend_button_checkout').css('display','block');
          $('.resend_button_reg').css('display','block');
          $('.before-timer').css('display','none');
          $('.resend_button').css('display','inline');
      return;
    }else{
          $('.resend_button_checkout').css('display','none');
          $('.resend_button_reg').css('display','none');
          $('.before-timer').css('display','inline');
          $('.resend_button').css('display','none');
    }
    displayTimeLeft(secondsLeft);
  }, 1000);
}

function displayTimeLeft(seconds){
	const minutes = Math.floor(seconds/60);
	const remainderSeconds = seconds % 60; 
	const display = `${minutes}:${remainderSeconds < 10 ? '0' : '' }${remainderSeconds}`;``
      //if(state == "login"){
        	var counter = document.getElementById("resendcountdown");
        //}else{
        //	var counter = document.getElementById("resendcountdown_reg");
        //}
    counter.innerHTML =  display;
}
    
       $('.resend_button_checkout a').click(function(){
        var mobNumber = $("#phn-num").val(); 
        mobileVerification(mobNumber);
        //$(".otp_msg").text('');
        //countdown(61);
        timer(60); 
      });
      $('.resend_button a').click(function(){
        var mobNumber = $("#phn-num").val(); 
        mobileVerification(mobNumber);
        //$(".otp_msg").text('');
        //countdown(61);
        timer(60); 
      });
  
  /*******************start extra code according to client requirement**********************/
  //setTimeout(()=>{$('.login-pop-up-mobile').show()},3000); // no need now
    
  var page_url = window.theme.canonical_url;
  var ExistPincode = localStorage.getItem('ExistPincode');
  // if((page_url.match("pepsodent")) && (ExistPincode)) {
  //     setTimeout(()=>{$('.login-pop-up-mobile').show()},3000); // for pepsodent page
  //  }
  //localStorage.setItem('redirect_after_login', "0");
    $('.icon-popup-close .bx-close-xsvg').click(function(){
        $(this).closest('.login-pop-up-mobile').hide();
    });
    
  if(window.theme.isCustomer){ 
     
     if(localStorage.getItem('close_update_popup') != '1'){
       //setTimeout(()=>{$('.customer_update_account_popup').show()},3000); // onload profile update popup will show aftr login  
     } 
     $(".update_details").click(function(){
          //$('.customer_update_account_popup').show();
      });
      $('.customer_update_account_popup-close .bx-close-xsvg').click(function(){
        localStorage.setItem('close_update_popup', "1");
        $(this).closest('.customer_update_account_popup').hide();
      });
  }
    
    if(body_class)
    {if(body_class.match('template-login')){ 
      if(window.theme.isCustomer){
      }else{
          localStorage.setItem('redirect_after_login', "0");
          $('.login-pop-up-mobile').show();
          $('body').addClass('popup-acc');
          $('.popup-blur').addClass('popup-blur-mobile');
        setTimeout(()=>{$('.login-pop-up-mobile').addClass('popup-active')},80);
     }
    }else if(body_class.match('template-page')){
	  if(window.theme.isCustomer){
      }else{
		  localStorage.setItem('redirect_after_login', "0");
	  }
	}
}
    $('.location-icon +.Header__Icon,.mob_login_customer').click(function(event){
      if(window.theme.isCustomer){
      }else{
          event.preventDefault();
          localStorage.setItem('redirect_after_login', "0");
          $('.login-pop-up-mobile').show();
          $('body').addClass('popup-acc');
          $('.popup-blur').addClass('popup-blur-mobile');
        setTimeout(()=>{$('.login-pop-up-mobile').addClass('popup-active')},80);
     }
    });

    if($(window).width() <= 640){
      $(".pop-send").click(function(){
           $(".banner-img").hide();
           $('.login-pop-up-mobile h1').css("margin-top","-5%");
     });
     $(".back_mobile_from").click(function(){
           $(".banner-img").show();
     });
     }
     $(".icon-popup-close").click(function(){
      $(".popup-blur").removeClass('popup-blur-mobile');
     $('body').removeClass('popup-acc');
});
$(".linklist-pop").click(function(){
  $('.login-pop-up-mobile').show();
$('body').addClass('popup-acc');
  $('.popup-blur').addClass('popup-blur-mobile');
  setTimeout(()=>{$('.login-pop-up-mobile').addClass('popup-active')},80);
});
  $('body').delegate('.login-pop-up-mobile .step__footer__continue-btn','click',function() { 
    localStorage.setItem('redirect_after_login', "1");
  });
  $('body').delegate('.openlogin span','click',function() {  
//     localStorage.setItem('redirect_after_login', "1");
//     $(".Drawer__Close.Icon-Wrapper--clickable").trigger('click');
//     $('.login-pop-up-mobile').show();
//     $('body').addClass('popup-acc');
//   $('.popup-blur').addClass('popup-blur-mobile');
//   setTimeout(()=>{$('.login-pop-up-mobile').addClass('popup-active')},80);
    $('body').find('.loader-checkout-block').css({'visibility':'visible', 'opacity':'1'});
    $(".loaderChekout-overlay").show();
     $('.loader-checkout-block').show();
    var ExistLocation_form = localStorage.getItem('currentLocationId');
    cartUpdateWhilePincodeUpdate(ExistLocation_form,false);
    onCheckoutMonthlyReview();
  });
  
  $('body').delegate('.openlogin_redirect span, .openlogin_redirect','click',function() {  
     gtag('event', 'begin_checkout', {'send_to': 'AW-11170593472/63jRCO_Y0p0YEMD1xs4p'});
  //   localStorage.setItem('redirect_after_login', "1");
  //   $(".Drawer__Close.Icon-Wrapper--clickable").trigger('click');
  //   $('.login-pop-up-mobile').show();
    $('body').find('.loader-checkout-block').css({'visibility':'visible', 'opacity':'1'});
    $(".loaderChekout-overlay").show();
    $('.loader-checkout-block').show();
    // $('body').find('.loader-checkout-block').css({'display':'block'});
   // $('body').find('.loaderChekout-overlay').css({'display':'block'});
    var ExistLocation_form = localStorage.getItem('currentLocationId');
    cartUpdateWhilePincodeUpdate(ExistLocation_form,false);
    onCheckoutMonthlyReview();
    //window.location.href = "/checkout?step=contact_information";
  });
  
  function onCheckoutMonthlyReview(){
     var array_over_gift = [];
    $.ajax({
       url:"/cart.json",
       type:"get",
       async:false,
       success:function(result1){
         result1.items.forEach(function(item){
               var ItemId = item.id;
               if(obj_monthly.hasOwnProperty(ItemId)){
                 var monthly_item_purchsed  = obj_monthly[ItemId];
                 var limit_monthly_item = 10;
                 var cart_monthly_value = $(".monthly_"+ItemId).val();
                 var total_monthly_cart_and_order = parseInt(monthly_item_purchsed) + parseInt(cart_monthly_value);
                 if(total_monthly_cart_and_order >=  limit_monthly_item ){
                     array_over_gift.push(ItemId);
                 }
               }
  
             });
         
             if(array_over_gift.length > 0){
               for(let i = 0; i < array_over_gift.length; i++){
               var id_free = array_over_gift[i];
                $.ajax({
                 type : 'POST',
                 url : '/cart/change.js',
                 data : {id : id_free, quantity: 0},
                 dataType : 'json',
                 async : false,
                 success :  function(data){
                   var redirect_free = array_over_gift.length - 1;
                   if(redirect_free == i){
                     window.location.href = "/checkout?step=contact_information";
                   }
                 },
                 error : function(){
                   //alert('error');
                 }
               });
             }
             }else{
               window.location.href = "/checkout?step=contact_information";
             }
               
       },
       error:function(){
       }
    });
  }
   //   Mobile Sidebar Account / Login
    $('body').delegate('.mob_login span','click',function(event) {  
      if(window.theme.isCustomer){
      }else{
        event.preventDefault();
        localStorage.setItem('redirect_after_login', "0");
        $(".Drawer__Close.Icon-Wrapper--clickable").trigger('click');
        $('.login-pop-up-mobile').show();
      }
    });
  
  
  /*******************end extra code according to client requirement**********************/
  if( $(window).width() >= 768 ){
          $('.otp_input').find('input').each(function() {
            $(this).attr('maxlength', 1);
            $(this).on('keyup', function(e) {
              $('.otp_msg').text('');
              var parent = $($(this).parent());

              if(e.keyCode === 8 || e.keyCode === 37) {
                var prev = parent.find('input#' + $(this).data('previous'));

                if(prev.length) {
                  $(prev).select();
                }
              } else if((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 39) {
                var next = parent.find('input#' + $(this).data('next'));

                if(next.length) {
                  if($(this).val()){
                    $(next).select();
                  }
                } else {
                  if(parent.data('autosubmit')) {
                    parent.submit();
                  }
                }
              }
            });
          });
        }else{
          $('.otp_input').find('input').each(function() {
            $(this).attr('maxlength', 1);
            $(this).on('keyup', function(e) {
              $('.otp_msg').text('');
              var parent = $($(this).parent());

              if(e.keyCode === 8 || e.keyCode === 37) {
                var prev = parent.find('input#' + $(this).data('previous'));

                if(prev.length) {
                  $(prev).val('')
                  $(prev).select();
                }
              } else {
                var next = parent.find('input#' + $(this).data('next'));

                if(next.length) {
                  $(next).select();
                } else {
                  if(parent.data('autosubmit')) {
                    parent.submit();
                  }
                }
              }
            });
          });
        }
  });